<a class="link-color flex flex-row justify-start items-center" (click)=onClick()
   particleAnalytics
   analyticsCategory="link-cell-viewer"
   *ngIf="item.cells[fieldDefinition.key]?.displayText !== 'N/A'"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
>
  <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis">
    <div *ngIf="item.cells[fieldDefinition.key]?.displayText"
         class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
      {{item.cells[fieldDefinition.key]?.displayText}} <i class="far fa-info-circle"
                                                          matTooltip="This is a permission filter."
                                                          style="padding-left: 5px;"
                                                          *ngIf="item.cells['IsPermissionFilter']?.value === true"></i>
    </div>
    <div *ngIf="!item.cells[fieldDefinition.key]?.displayText"
         class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
      Attach to Task
    </div>
  </div>
</a>
<div *ngIf="item.cells[fieldDefinition.key]?.displayText === 'N/A'">
  {{item.cells[fieldDefinition.key]?.displayText}}
</div>
